module.exports = __webpack_public_path__ + "img/light.7116d6b0.png";